// Mouse drag that keeps tracking outside the element: onMove(event) until the button is released.
// Returns a function that ends the drag early (e.g. on unmount).
export function trackDrag(onMove, cursor, onEnd) {
  const body = document.body.style;
  let done = false;
  const stop = () => {
    if (done) return;
    done = true;
    window.removeEventListener("mousemove", onMove);
    window.removeEventListener("mouseup", stop);
    body.cursor = "";
    body.userSelect = "";
    onEnd && onEnd();
  };
  window.addEventListener("mousemove", onMove);
  window.addEventListener("mouseup", stop);
  body.cursor = cursor;
  body.userSelect = "none";
  return stop;
}
